import React,{useState, useEffect} from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import OfferSection from "./Components/OfferSection";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import Loader from "./Components/Loader";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  };
  
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const OfferPageEdit=()=>{

    
    useEffect(()=>{
        document.title="Offer | Balaji Badminton Academy"
      },[]);

    return(
        <>
            <Header/>
            <Loader/>
            <OfferSection/>
            <Footer/>
        </>
    );
}

export default OfferPageEdit;